
import { Vue, Component, Prop } from "vue-property-decorator";
import UiButton from "@/components/button/ui-button.vue";
import RouteParams from "@/entities/RouteParams";

@Component({
  components: {
    UiButton,
  }
})
export default class SchedulerCustomModalHeader extends Vue {
  @Prop({ type: Boolean, default: false }) isEdittingLocked!: boolean;
  @Prop({ type: String, default: "" }) buttonText!: string;
  @Prop({ type: Object, default: () => ({})}) linkObject!: RouteParams<{ id: string }>;
  @Prop({ type: String, default: "Go To Project Page" }) linkText!: string;

  handleEditClick(): void {
    this.$emit("editClicked")
  }

  get isLinkObjectValid(): boolean {
    return Boolean(this.linkObject.params?.id);
  }
}
